import { createApp } from 'vue';
import { createPinia } from 'pinia';
import AltoneoUI from 'altoneo-charting';

import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import './assets/main.css';

import App from './App.vue';
import { router } from './router';
import { initPreferences } from './lib/preferences';
import { useDecouverteStore } from './stores/decouverte';

// Thème, contraste et taille de texte AVANT le montage : sinon l'écran clignote.
initPreferences();

const pinia = createPinia();
const app = createApp(App).use(pinia);
// Le mode démo est relu AVANT le routeur : sa première garde appelle `/me`,
// qui doit déjà partir vers le bon monde (données fictives ou vraies).
useDecouverteStore(pinia).hydrater();
app.use(router).use(AltoneoUI).mount('#app');
